import React from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
class GreetingsPopup extends AbstractWelcomePage {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            hide: true
        };
    }
    render() {
        var name = "";
        let us = localStorage.getItem("user");
        if (us != null) {
            var user = JSON.parse(us?.toString());
            if (user.result == 1) {
                name = user.name;
            }
        }
        let intestazione = this.props.t('GreetingsPopupKA.intestazione', { name });
        return (React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "modal-content" },
                React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                React.createElement("h1", { className: "testoPopup" }, intestazione),
                React.createElement("h4", { className: "testoPopup", style: { marginBottom: '-5px' } }, this.props.t('GreetingsPopupKA.intestazione2')),
                React.createElement("h4", { className: "testoPopup" }, this.props.t('GreetingsPopupKA.intestazione3')))));
    }
}
export default translate(connect(_mapStateToProps)(GreetingsPopup));
